// The request defaults that DRIVE PRICING, in one place.
//
// These live here rather than beside their callers so that anything pricing-driving
// is resolved one way. `duration` feeds credits.estimate_rough's words-per-scene
// divisor and its music seconds on the engine, so the value sent at submit decides
// the size of the credit hold — and the engine cannot paper over a drift, because
// it only sees the field the client sent (an omitted `duration` is indistinguishable
// from a deliberate 10). When two callers once resolved these differently, users
// were quoted ~0.94 credits on a job that then reserved 1.48. Whoever changes a
// default here changes what the engine holds for every default submission.

export const DEFAULT_MODEL_NAME = 'wan-i2v';

// Seconds per scene for Kling/LTX. Matches the backend's GenerateRequest default.
// The engine accepts 5 or 10; we don't silently downgrade to 5 when the user hasn't
// chosen one (there is no duration control in the main UI).
export const DEFAULT_DURATION_SECONDS = 10;

// Wan ignores the requested duration and always renders 6s/scene — matches the
// backend's WAN_CLIP_DURATION_S (app/llm/wan.py). Sending the real value keeps
// Generation Details honest, and keeps the quote equal to the hold.
export const WAN_DURATION_SECONDS = 6;

export function resolveModelName(modelName?: string | null): string {
  return modelName || DEFAULT_MODEL_NAME;
}

/** Seconds per scene the backend will price this request at. */
export function resolveDurationSeconds(
  modelName?: string | null,
  duration?: number | null,
): number {
  // An explicit choice always wins — including one that happens to equal a default.
  if (duration != null) return duration;
  return resolveModelName(modelName).startsWith('wan')
    ? WAN_DURATION_SECONDS
    : DEFAULT_DURATION_SECONDS;
}
